var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M27.988,10.09 c-0.107,2.476-1.739,5.866-4.895,10.168C19.83,24.752,17.069,27,14.811,27c-1.399,0-2.583-1.369-3.55-4.106 c-0.646-2.509-1.291-5.018-1.937-7.527c-0.718-2.736-1.488-4.106-2.312-4.106c-0.18,0-1.262,1.239-1.262,1.239L4.375,11 c0,0,3.625-6,6.75-6c2,0,2.952,1.486,3.383,4.383c0.466,3.125,0.789,5.068,0.97,5.829C16.016,17.805,16.603,19,17.25,19 c0.502,0,1.263-0.742,2.269-2.423C20.375,15.125,20.927,12.879,21,12c0-1.125-0.5-2-1.5-2c-0.375,0-1.125,0.125-1.5,0.875 c1.125-3,3.125-5.875,6.502-5.87C26.968,5.082,28.13,6.776,27.988,10.09z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.ec3e20cc02cb73282bcf8a1189f74f28.svg";
export { ForwardRef as ReactComponent };